{
  "version": "2026-10-25.v1",
  "source": "postgres-dwh-gvn / analytic / datamart_sales.f_sales cat_1_name → cat_3_name (90 ngày tới 2026-10-25); nhóm target = 4 ngành target BOD (nta_dashboard_cfo BOD_CATEGORIES), PERI chia theo nhóm target thương hiệu (KB / MOUSE / HEADSET / CHAIR).",
  "note": "Nhóm target suy ra TẤT ĐỊNH từ mã PIM leaf (ai_subcategory), lùi về mã nhóm (ai_category) khi leaf trống. Model không chọn nhóm target. Lệch có chủ đích so với nhóm masterdata: Túi chống sốc / Balo / RAM laptop / Phụ kiện laptop / Đế tản nhiệt nằm ở Laptop, Phần mềm nằm ở Màn hình Group — đúng như DWH. Lượt need_type=service luôn là SVC.",
  "groups": [
    {"code": "LCD", "label": "Màn hình", "parent": "LCD"},
    {"code": "PCD", "label": "Thiết bị PC", "parent": "PCD"},
    {"code": "LTD", "label": "Laptop", "parent": "LTD"},
    {"code": "PED_KB", "label": "Bàn phím", "parent": "PED"},
    {"code": "PED_MOUSE", "label": "Chuột", "parent": "PED"},
    {"code": "PED_HEADSET", "label": "Tai nghe", "parent": "PED"},
    {"code": "PED_CHAIR", "label": "Ghế / Bàn", "parent": "PED"},
    {"code": "PED_OTHER", "label": "Peri khác", "parent": "PED"},
    {"code": "SVC", "label": "Dịch vụ", "parent": "SVC"},
    {"code": "OTHER", "label": "Khác / chưa rõ", "parent": "OTHER"}
  ],
  "parents": [
    {"code": "LCD", "label": "Màn hình"},
    {"code": "PCD", "label": "Thiết bị PC"},
    {"code": "LTD", "label": "Laptop"},
    {"code": "PED", "label": "PERI"},
    {"code": "SVC", "label": "Dịch vụ"},
    {"code": "OTHER", "label": "Khác / chưa rõ"}
  ],
  "by_category": {
    "PC": "PCD",
    "LINH_KIEN": "PCD",
    "MAN_HINH": "LCD",
    "PHAN_MEM": "LCD",
    "LAPTOP": "LTD",
    "GEAR": "PED_OTHER",
    "GHE_BAN": "PED_CHAIR",
    "THIET_BI_MANG": "PED_OTHER",
    "PHU_KIEN": "PED_OTHER",
    "DICH_VU": "SVC",
    "APPLE": "OTHER",
    "VAN_PHONG": "OTHER",
    "OTHER": "OTHER",
    "UNKNOWN": "OTHER"
  },
  "by_subcategory": {
    "KB": "PED_KB",
    "CHU": "PED_MOUSE",
    "TAI": "PED_HEADSET",
    "TAI-AUDIO": "PED_HEADSET",
    "GHE": "PED_CHAIR",
    "BAN": "PED_CHAIR",
    "PK-LAP": "LTD",
    "RAM-LAP": "LTD",
    "TUI": "LTD",
    "BALO": "LTD",
    "DTN": "LTD"
  }
}
